export default __webpack_public_path__ + "static/media/news-9.8bf92290.jpg";